import { DateTime } from 'luxon';

import { API_DATE_FORMAT, DATE_FORMAT } from './constants';

export const convertApiDateToDateTime = (date: string): DateTime | null => {
  if (date) {
    const formattedDate = DateTime.fromFormat(date, API_DATE_FORMAT);
    return formattedDate.isValid ? formattedDate : null;
  }

  return null;
};

export const convertDateTime = (
  date: DateTime | null,
  format: string
): string => {
  if (DateTime.isDateTime(date)) {
    return date.toFormat(format);
  }

  return '';
};

export const convertToApiDateString = (date: DateTime | null): string =>
  convertDateTime(date, API_DATE_FORMAT);

export const convertToDateString = (date: DateTime | null): string =>
  convertDateTime(date, DATE_FORMAT);
